import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function TrussEnvelopesContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="trussEnvelope" />
    </SceneMenuContent>
  );
}
